<div class="content">
    <div class="item">
        <app-annual-grade class="annual-grade-component-width" annualGrade="Very good"
            description="Water quality is suitable for swimming almost all of the time, with very few potential sources of faecal contamination">
        </app-annual-grade>
    </div>

    <div class="item">
        <app-annual-grade class="annual-grade-component-width" annualGrade="Good"
            description="Water quality is suitable for swimming for most of the time, but due to the presence of several potential sources of faecal contamination, swimming should be avoided following rainfall">
        </app-annual-grade>
    </div>

    <div class="item">
        <app-annual-grade class="annual-grade-component-width" annualGrade="Fair"
            description="Water quality is often suitable for swimming, but due to the presence of significant sources of faecal contamination, extra care should be taken to avoid swimming following rainfall.">
        </app-annual-grade>
    </div>

    <div class="item">
        <app-annual-grade class="annual-grade-component-width" annualGrade="Poor"
            description="Water quality is often unsuitable for swimming. Before swimming during dry weather, ensure the water is free from signs of pollution such as discoloured water, odour and floating debris. Avoid swimming at all times following rainfall.">
        </app-annual-grade>
    </div>

    <div class="item">
        <app-annual-grade class="annual-grade-component-width" annualGrade="Very poor"
            description="Water quality is often unsuitable for swimming. It is recommended to avoid swimming at these sites almost all of the time.">
        </app-annual-grade>
    </div>
    <div class="item">
        <app-annual-grade class="annual-grade-component-width" annualGrade="Follow up"
            description="The sanitary inspection and water quality data produce incongruent results. Further assessment is required to get necessary data to provide a definite classification in accordance with national guidelines.">
        </app-annual-grade>
    </div>
</div>
